import api from 'src/utils/api/core'

export function ping() {
  return api.get(`/ping`)
}
